/*
INSTRUCTIONS

import those shits

import ShareDialog from '../ShareDialog';
import { constructShareLink } from '../../shared/Helpers';
import ShareIcon from '@material-ui/icons/Share';


add shareDialogOpen to state of component

      shareDialogOpen: false,


add these bad bois

    this.handleShareDialogOpen = this.handleShareDialogOpen.bind(this);
    this.handleShareDialogClose = this.handleShareDialogClose.bind(this);
    this.handleCopy = this.handleCopy.bind(this);


make sure location and shareDialogOpen are imported in render

    const { location } = this.props;
    const { shareDialogOpen } = this.state;


gunna need these bad bitches

  handleShareDialogOpen() {
    this.setState({ shareDialogOpen: true });
  }
  handleShareDialogClose() {
    this.setState({ shareDialogOpen: false });
  }
  handleCopy(link) {
    navigator.clipboard.writeText(link);
    this.setState({
      snackbarOpen: true,
      snackbarMessage: 'Link Copied',
      snackbarVariant: 'success',
    });
  }


add this shiz

{/* SHARE DIALOG *}
<ShareDialog
  open={shareDialogOpen}
  link={constructShareLink(location)}
  handleCopy={() => this.handleCopy(constructShareLink(location))}
  handleClose={this.handleShareDialogClose}
/>


add a button kinda like dis

<Button size="small" variant="outlined" color="secondary" onClick={this.handleShareDialogOpen} endIcon={<ShareIcon />}>Share</Button>

*/

import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';

const styles = theme => ({

});

const ShareDialog = (props) => {
  const {
    open,
    link,
    handleCopy,
    handleClose,
  } = props;

  return (
    <Dialog
      open={open}

    >
      <DialogTitle>Share</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          value={link}
          variant="outlined"
          color="secondary"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={handleCopy}>Copy</Button>
        <Button variant="outlined" color="secondary" onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

ShareDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  link: PropTypes.string.isRequired,
  handleCopy: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(ShareDialog);
